import { GALLERY_SCHEMA } from "../../consts/Template";

const Blank = {
  [GALLERY_SCHEMA.ID]: "blank",
  [GALLERY_SCHEMA.NAME]: "Blank",
  [GALLERY_SCHEMA.CATEGORY]: null,
  template_content: `<mjml>
  <mj-head>
    <mj-style>
      p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
      ul, ol { margin-block-start:0; margin-block-end:0; padding-block-start:0; padding-block-end:0; Margin:0; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f0f0f0">
    <mj-section
      padding-top="3px"
      padding-bottom="3px"
      padding-left="3px"
      padding-right="3px"
      background-color="transparent">
      <mj-column>
        <mj-spacer height="8px" container-background-color="transparent"></mj-spacer>
      </mj-column>
    </mj-section>
    <mj-section
      padding-top="8px"
      padding-bottom="20px"
      padding-left="20px"
      padding-right="20px"
      background-color="#ffffff">
      <mj-column>
        <mj-spacer height="10px" container-background-color="transparent"></mj-spacer>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  [GALLERY_SCHEMA.PREVIEW]: `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; }
    table, td { border-collapse: collapse; }
    p { display: block; margin: 0; }
    p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
    ul, ol { margin-block-start: 0; margin-block-end: 0; padding-block-start: 0; padding-block-end: 0; Margin: 0; }
  </style>
</head>
<body style="word-spacing:normal;background-color:#f0f0f0;">
  <div style="background-color:#f0f0f0;">
    <!-- Top Spacer -->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:3px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td style="background:transparent;font-size:0px;word-break:break-word;">
                        <div style="height:8px;line-height:8px;">&#8202;</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Canvas Area -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px;padding-top:8px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td style="background:transparent;font-size:0px;word-break:break-word;">
                        <div style="height:500px;line-height:500px;">&#8202;</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</body>
</html>`,
};
export default Blank;
